import { type ClientContext, ContextClient } from '~/services/contextClient';
import ScheduledMessagesFactory from './scheduledMessagesClient.factory';
import type { ScheduledMessagesClientInterface, ScheduledMessage } from './scheduledMessagesClient.types';
import type { CursorPaginationResponse, QueryParams } from '~/services/api';
import type { AxiosPromise } from 'axios';
import type { ExtendedAxiosRequestConfig } from '../BaseClient';

class ScheduledMessagesClient extends ContextClient<ScheduledMessagesClientInterface> {
    constructor() {
        super(ScheduledMessagesFactory);
    }

    getScheduledMessages(
        context: ClientContext,
        params?: QueryParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<CursorPaginationResponse<ScheduledMessage>> {
        const client = this.getClient(context);
        return client.getScheduledMessages(params, config);
    }

    getScheduledMessagesCount(
        context: ClientContext,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<{ count: number }> {
        const client = this.getClient(context);
        return client.getScheduledMessagesCount(config);
    }

    getContactScheduledMessages(
        context: ClientContext,
        contactId: number,
        params?: QueryParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<CursorPaginationResponse<ScheduledMessage>> {
        const client = this.getClient(context);
        return client.getContactScheduledMessages(contactId, params, config);
    }

    createScheduledMessage(
        context: ClientContext,
        contactId: number,
        data: ScheduledMessage
    ): AxiosPromise<ScheduledMessage> {
        const client = this.getClient(context);
        return client.createScheduledMessage(contactId, data);
    }

    deleteScheduledMessage(context: ClientContext, contactId: number, scheduledMessageId: number): AxiosPromise<void> {
        const client = this.getClient(context);
        return client.deleteScheduledMessage(contactId, scheduledMessageId);
    }
}

export default new ScheduledMessagesClient();
